export const CALL_FILTER_ACTION = {
  UPDATE_FILTER: 'UPDATE_FILTER',
}

export const updateCallFilter = (filter) => ({
  type: CALL_FILTER_ACTION.UPDATE_FILTER,
  payload: {
    filter: filter
  }
})